import React from 'react';

import { Description, LediumForm, TitleAndDescription, UniqueName } from '@ledium/ui-common';
import { Container } from '@mui/material';

import SpectrumMixerChannelSettings from './Components/SpectrumMixerChannelSettings';
import SpectrumMixerChart from './Components/SpectrumMixerChart';
import SpectrumMixerCreateLightRecipe from './Components/SpectrumMixerCreateLightRecipe';
import SpectrumMixerDetailedIntensityInfo from './Components/SpectrumMixerDetailedIntensityInfo';
import SpectrumMixerDownloadCsv from './Components/SpectrumMixerDownloadCsv';
import SpectrumMixerSelectLightRecipe from './Components/SpectrumMixerSelectLightRecipe';
import SpectrumMixerSettings from './Components/SpectrumMixerSettings';

interface SpectrumMixerViewProps {
    onSave: () => void;
    onClose: () => void;
}

const SpectrumMixerView = ({ onSave, onClose }: SpectrumMixerViewProps) => (
    <Container data-automation="spectrum-mixer-form">
        <LediumForm onSubmit={() => onSave()} onCancel={onClose} header={<TitleAndDescription />}>
            <UniqueName />
            <Description />
            <SpectrumMixerSelectLightRecipe />
            <SpectrumMixerCreateLightRecipe />

            <SpectrumMixerSettings />
            <SpectrumMixerChannelSettings />
            <SpectrumMixerChart />
            <SpectrumMixerDetailedIntensityInfo />
            <SpectrumMixerDownloadCsv />
        </LediumForm>
    </Container>
);

export default SpectrumMixerView;
